import {
  FieldWrapper,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import {
  ExpressionType,
  IterableType,
  TBatchWorkflowStepDefinition,
  TIterableProvider,
  TWorkflowDefinition,
} from '@commenda/types';
import { useState } from 'react';
import { ExprEditor } from './ExperssionEditor';

export const IteratorEditor = ({
  iterator,
  onChange,
  workflowDefinition,
  stepId,
}: {
  iterator: TIterableProvider;
  onChange: (iterator: TIterableProvider) => void;
  workflowDefinition: TWorkflowDefinition;
  stepId: string;
}) => {
  const [iteratorType, setIteratorType] = useState<IterableType>(
    iterator?.type
  );

  const stepDefinition = workflowDefinition.steps.find(
    (step) => step.id === stepId
  ) as TBatchWorkflowStepDefinition;

  return (
    <div className="flex flex-col gap-2">
      <FieldWrapper>
        <Label>Iterator Type</Label>
        <Select
          value={iteratorType}
          onValueChange={(type: IterableType) => setIteratorType(type)}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {Object.values(IterableType).map((type) => (
              <SelectItem key={type} value={type}>
                {type}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FieldWrapper>
      {iteratorType === IterableType.EXPRESSION && (
        <ExprEditor
          value={
            iterator?.type === IterableType.EXPRESSION
              ? iterator.expr
              : { type: ExpressionType.JSONATA, src: '' }
          }
          onChange={(expr) => onChange({ type: IterableType.EXPRESSION, expr })}
        />
      )}
      {iteratorType === IterableType.STEP && (
        <FieldWrapper>
          <Label>Step ID</Label>
          <Select
            value={iterator?.type === IterableType.STEP ? iterator.stepId : ''}
            onValueChange={(selectedStepId) =>
              onChange({ type: IterableType.STEP, stepId: selectedStepId })
            }
          >
            <SelectTrigger>
              <SelectValue placeholder="Select step" />
            </SelectTrigger>
            <SelectContent>
              {workflowDefinition.steps
                .filter((step) => step.outputSchema)
                .map((step) => (
                  <SelectItem key={step.id} value={step.id}>
                    {step.name}
                  </SelectItem>
                ))}
            </SelectContent>
          </Select>
          <ExprEditor
            value={
              iterator?.type === IterableType.STEP && iterator?.select
                ? iterator.select
                : { type: ExpressionType.JSONATA, src: '' }
            }
            onChange={(expr) =>
              onChange({
                type: IterableType.STEP,
                stepId,
                select: expr,
              })
            }
          />
        </FieldWrapper>
      )}
      {iteratorType === IterableType.DATASOURCE && (
        <FieldWrapper>
          <Label>Data Source ID</Label>
          <Select
            value={
              iterator?.type === IterableType.DATASOURCE ? iterator.key : ''
            }
            onValueChange={(selectedDataSourceId) =>
              onChange({
                type: IterableType.DATASOURCE,
                key: selectedDataSourceId,
              })
            }
          >
            <SelectTrigger>
              <SelectValue placeholder="Select data source" />
            </SelectTrigger>
            <SelectContent>
              {stepDefinition?.dataSources?.map((eachDataSource) => (
                <SelectItem key={eachDataSource.id} value={eachDataSource.id}>
                  {eachDataSource.id}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <ExprEditor
            value={
              iterator?.type === IterableType.DATASOURCE && iterator?.select
                ? iterator.select
                : { type: ExpressionType.JSONATA, src: '' }
            }
            onChange={(expr) =>
              onChange({
                type: IterableType.DATASOURCE,
                key:
                  stepDefinition?.iterable?.type === IterableType.DATASOURCE
                    ? stepDefinition?.iterable?.key
                    : '',
                select: expr,
              })
            }
          />
        </FieldWrapper>
      )}
    </div>
  );
};
